<template>
  <CRow>
    <CCol col="12" xl="8">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          Locations
          <CButton size="sm" style="float:right;" color="success" @click="addModal = true">Add Location</CButton>
        </CCardHeader>
        <CCardBody>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <div class="col-12 float-left text-right">
            <input type="checkbox" v-model="showDeleted" @click="getData()"><label style="padding-left:5px;">Show Deleted Locations</label></div>
          </div>
          <div class="col-12 float-left">
            <CDataTable
              v-if="!loading"
              :items="items"
              :fields="fields"
              column-filter
              table-filter
            >
              <!-- <template #show="{item}">
                <td>
                  <CButton size="sm" color="primary" @click="show( item.program_id )">Show</CButton>
                </td>
              </template> -->
              <template #edit="{item}">
                <td>
                  <CButton size="sm" color="primary" @click="edit( item )">Edit</CButton>
                </td>
              </template>
              <template #deleted="{item}">
                <td>
                  <label v-if="item.deleted" style="color: red;">Deleted</label>
                </td>
              </template>
              <!-- <template #delete="{item}">
                <td>
                  <CButton size="sm" v-if="you!=item.id" color="danger" @click="deleteUser( item.id )">Delete</CButton>
                </td>
              </template> -->
            </CDataTable>
            <small-loader v-else />
          </div>
        </CCardBody>
      </CCard>
      </transition>

      <CModal
        title="Add Style"
        :show.sync="addModal"
      >
        <CForm>
          <CInput
            :lazy="false"
            label="Location Name"
            :value.sync="form.location_name"
            placeholder="Location Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Location Code"
            :value.sync="form.location_code"
            placeholder="Location Code"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Program</label>
            <v-select v-model="form.program" v-if="programOptions" :options="programOptions"></v-select>
          </div>
          <div style="padding-bottom:15px;">
            <label>Location Image</label>
            <v-select v-model="form.location_image" :options="['front', 'left-side', 'right-side', 'back']"></v-select>
          </div>
          <div style="padding-bottom:15px;">
            <label>Product Class</label>
            <v-select v-model="form.product_class" v-if="productClasses" :options="productClasses"></v-select>
          </div>
          <CInput
            :lazy="false"
            label="Cost"
            :value.sync="form.cost"
            placeholder="Cost"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Combined Location?</label>
            <div>
              <CButton size="sm" @click="form.combined = 1" :color="form.combined === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.combined = 0" style="margin-left:5px;" :color="form.combined === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
        </CForm>
        <template #footer>
          <CButton @click="addModal = false, reset()" color="danger">Cancel</CButton>
          <CButton @click="add()" color="success">Add</CButton>
        </template>
      </CModal>

      <CModal
        title="Edit Location"
        :show.sync="editModal"
      >
        <CForm v-if="editForm">
          <CInput
            :lazy="false"
            label="Location Name"
            :value.sync="editForm.location_name"
            placeholder="Location Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Location Code"
            :value.sync="editForm.location_code"
            placeholder="Location Code"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="padding-bottom:15px;">
            <label>Program</label>
            <v-select v-model="editForm.program" v-if="programOptions" :options="programOptions"></v-select>
          </div>
          <div style="padding-bottom:15px;">
            <label>Location Image</label>
            <v-select v-model="editForm.location_image" :options="['front', 'left-side', 'right-side', 'back']"></v-select>
          </div>
          <div style="padding-bottom:15px;">
            <label>Product Class</label>
            <v-select v-model="editForm.product_class" v-if="productClasses" :options="productClasses"></v-select>
          </div>
          <CInput
            :lazy="false"
            :value.sync="editForm.cost"
            label="Cost"
            placeholder="Cost"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Combined Location?</label>
            <div>
              <CButton size="sm" @click="editForm.combined = 1" :color="editForm.combined === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="editForm.combined = 0" style="margin-left:5px;" :color="editForm.combined === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>

          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Delete Location</label>
            <div>
              <CButton size="sm" @click="editForm.deleted ? editForm.deleted = 0 : editForm.deleted = 1" :color="editForm.deleted === 1 ? 'danger': 'outline-danger'" >Deleted</CButton>
              <!-- <CButton size="sm" v-else-if="editForm.deleted" @click="editForm.deleted = 0" color="danger">Activate</CButton> -->
            </div>
          </div>
        </CForm>
        <template #footer>
          <CButton @click="editModal = false, resetEdit()" color="danger">Cancel</CButton>
          <CButton @click="save()" color="success">Save</CButton>
        </template>
      </CModal>
    </CCol>
  </CRow>
</template>

<script>
var methods = {}

methods.getData = function () {
  this.loading = true
  const postData = {
    showDeleted: this.showDeleted
  }
  let self = this
  console.log(postData)
  axios.post( this.$apiAdress + '/api/locations?token=' + localStorage.getItem("api_token"), postData)
  .then(function (response) {
    console.log(response)
    self.items = response.data
    self.loading = false
  }).catch(function (error) {
    console.log(error)
  });
}

methods.getPrograms = function () {
  let self = this
  axios.get( this.$apiAdress + '/api/programs?token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    // self.programOptions = response.data
    var arr = []
    response.data.forEach(function (val) {
      arr.push(val.program_name)
    })
    self.programOptions = arr
  }).catch(function (error) {
    console.log(error)
  });
}

methods.getProductClasses = function () {
  let self = this
  axios.post( this.$apiAdress + '/api/styles/getProductClasses?token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    // self.programOptions = response.data
    var arr = []
    response.data.forEach(function (val) {
      arr.push(val.product_class)
    })
    self.productClasses = arr
  }).catch(function (error) {
    console.log(error)
  });
}

methods.reset = function () {
  this.form = {name: ''}
}

methods.resetEdit = function () {
  this.editModal = null
}

methods.edit = function (val) {
  // this.$router.push({ path: '/styles/' + val + '/edit' })
  this.editForm = val
  this.editModal = true
}

methods.save = function () {
  let self = this
  axios.post(this.$apiAdress + '/api/locations/update?token=' + localStorage.getItem('api_token'), self.editForm)
  .then(function (response) {
    self.editForm = null
    self.editModal = false
  }).catch(function (error) {
    console.log(error)
  })
}

methods.add = function () {
  let self = this;
  axios.post(   this.$apiAdress + '/api/locations/store?token=' + localStorage.getItem("api_token"),
    self.form
  )
  .then(function (response) {
      console.log(response)
      self.items.push(response.data)
      self.form = {style_name: ''}
      self.addModal = false
  }).catch(function (error) {
      // if(error.response.data.message == 'The given data was invalid.'){
      //   self.message = '';
      //   for (let key in error.response.data.errors) {
      //     if (error.response.data.errors.hasOwnProperty(key)) {
      //       self.message += error.response.data.errors[key][0] + '  ';
      //     }
      //   }
      //   self.showAlert();
      // }
  });
}

methods.getForm = function () {
  return {
    location_name: '',
    cost: 0,
    location_code: '',
    product_class: '',
    program: '',
    combined: '',
    location_image: ''
  }
}

export default {
  name: 'Locations',
  data() {
    return {
      items: [],
      fields: ['location_name', 'location_code', 'product_class', 'program', 'cost', 'combined', 'deleted', 'edit'],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      showDeleted: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      programOptions: null,
      showDismissibleAlert: false,
      addModal: false,
      form: this.getForm(),
      editForm: null,
      editModal: false,
      productClasses: null,
      loading: true
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  methods: methods,
  mounted: function(){
    this.getData()
    this.getPrograms()
    this.getProductClasses()
  }
}
</script>
